(function () {
	angular
		.module('trackeye')
		.factory('AuthService', AuthService);

	AuthService.$inject = ['C4ApiService', '$q', '$sessionStorage', '$localStorage', '$state', '$injector', '$timeout', 'NotificationService', 'LogService', 'LanguageService'];

	/**
	 *
	 * @param api
	 * @param $q
	 * @param $sessionStorage
	 * @param $localStorage
	 * @param $state
	 * @param $injector
	 * @param NotificationService
	 * @param Log
	 * @constructor
	 */
	function AuthService(api, $q, $sessionStorage, $localStorage, $state, $injector, $timeout, NotificationService, Log, LanguageService) {
		var impersonateCheck = false,
			remoteAuthCheck = false,
			impersonating = false,
			expirePhase = false,
			exports = {};

		/**
		 * #192 - This should maybe only check if the token is expired
		 * Return access token, if the client is authenticated
		 * @returns {string|undefined} Access token
		 */
		exports.getAccessToken = function () {
			if (!exports.hasToken())
				return undefined;

			return $sessionStorage.token.access;
		};

		/**
		 * #192 - This should maybe only check if the token exists
		 */
		exports.getRefreshToken = function () {
			if (!exports.hasToken())
				return undefined;

			return $sessionStorage.token.refresh;
		};

		exports.setAccessToken = function (token) {
			if (!$sessionStorage.token)
				$sessionStorage.token = {};

			angular.extend($sessionStorage.token, {access: token});
		};

		exports.authenticate = function (auth) {
			//@todo Need something to check if ident is username or email
			exports.flush();

			var locale = LanguageService.getDefaultLanguage();
			return api.token(auth.username, auth.password, locale).then(function (resp) {
				exports.saveToken({
					token: resp.data,
					remember: auth.remember
				});
			});
		};

		exports.authenticateByRefresh = function (token) {
			return api.local('POST', 'oauth2/refresh', {
				token: token
			},{}, true, true).then(function(resp) {
				exports.saveToken({
					token: resp.data,
					remember: true
				});
			});
		};
		
		exports.authenticateByCode = function(code, state, remember) {
			var locale = LanguageService.getDefaultLanguage();
			return api.tokenByCode(code, state, locale).then(function (resp) {
				exports.saveToken({
					token: resp.data,
					remember: remember
				})
			})
		}

		/**
		 * Deletes the current stored token
		 */
		exports.flush = function () {
			_log('Token credentials flushed.');
			delete $sessionStorage.token;
		};

		exports.flushPersistentToken = function () {
			_log('Flushed persistent token');
			delete $localStorage.session;
		};

		/**
		 *
		 * @param {string} [token]
		 * @param {boolean} [remember]
		 * @returns {Promise}
		 */
		exports.refresh = function (token, remember) {
			var defer = $q.defer();

			token = token || exports.getRefreshToken();

			if (!token) {
				api.LogINFO('authservice: Cannot refresh access token, without any refresh_token');
				defer.reject(false);
			} else {
				api.token_refresh(token).then(function (resp) {
					exports.saveToken({
						token: resp.data,
						remember: remember
					});
					defer.resolve(resp);
				}, defer.reject);
			}

			return defer.promise;
		};

		/**
		 * Asserts if the token object is set.
		 *
		 * @returns {boolean}
		 */
		exports.hasToken = function () {
			if (!$sessionStorage.token) {
				return false;
			}

			return true;
		};

		exports.isExpired = function () {
			var expires = new Date($sessionStorage.token.expires),
				now = new Date();

			if (now.getTime() > expires.getTime()) {
				_log("Access token has expired");
				return true;
			}

			return false;
		}

		exports.isInExpirePhase = function () {
			return expirePhase;
		};

		/**
		 * Save authentication token
		 * @param {object} ident
		 * @param {boolean} [impersonate]
		 */
		exports.saveToken = function (ident, impersonate) {
			var now = new Date(),
				expires = now.setTime(now.getTime() + (ident.token.expires_in * 1000));

			$sessionStorage.token = {
				access: ident.token.access_token,
				refresh: ident.token.refresh_token,
				type: ident.token.token_type,
				expires: expires,
				impersonate: !!impersonate
			};

			var expires_in = (expires - (new Date()).getTime()) / 1000 / 60;
			_log("Session expires in " + expires_in + " minutes");

			if (ident.remember && !impersonate)
				exports.rememberToken();
		};

		exports.rememberToken = function() {
			$localStorage.session = $sessionStorage.token.refresh;
		};

		exports.impersonate = function (access_token) {
			impersonating = true;

			exports.saveToken({
				token: {
					access_token: access_token,
					expires_in: 1800,
					token_type: "bearer",
					refresh_token: undefined
				}
			}, impersonating);

			return exports.check(false).then(function(data) {
				Log.setAccount('impersonate:N/A');
			}, function () {
				exports.flush();
			});
		};

		exports.remoteAuth = function(token) {
			if ($state.is('main.remote_auth') && !remoteAuthCheck) {
				remoteAuthCheck = true;

				token = decodeURIComponent(token);
				token = atob(token);
				token = JSON.parse(token);
				exports.saveToken({
					token: token
				});

				exports.check(false).then(function() {
					$state.go('dashboard.main.pages', {page: 'positions'});
				}, function() {
					exports.flush();
				}).finally(function() {
					remoteAuthCheck = false;
				});
			}
		}

		exports.checkImpersonate = function () {
			if ($state.is('main.impersonate') && !impersonateCheck) {
				impersonateCheck = true;
				exports.impersonate($state.params.impersonate_token).then(function(data) {
					$state.go('dashboard.main.pages', {page: 'positions'})
				}, function() {
					NotificationService.warning('Session token is invalid');
					$state.go('main');
				}).finally(function() {
					impersonateCheck = false;
				});
			}
		};

		exports.isImpersonating = function () {
			return impersonating;
		};

		/**
		 * Check if token is valid, if not, try to refresh it.
		 * @param {boolean} [try_refresh]
		 * @returns {Promise}
		 */
		exports.check = function (try_refresh) {
			var defer = $q.defer();

			try_refresh = angular.isDefined(try_refresh) ? try_refresh : true;

			api.check(impersonating).then(defer.resolve, function () {
				if (try_refresh) {
					exports.refresh().then(defer.resolve, defer.reject);
				} else {
					defer.reject();
				}
			});
			return defer.promise;
		};

		/**
		 * Request password reset link
		 * @param {string} email 
		 */
		exports.requestReset = function (email) {
			return api.local('post', 'reset/password', {email: email});
		}

		exports.logout = function () {
			exports.flush();
			$injector.get('DeviceService').flush();
			$injector.get('AccountService').flush();
			$injector.get('ConfigurationService').flush();
			$injector.get('CacheFactory').clearAll();
		}

		/**
		 * Open a modal, that prompts the user for credentials
		 * if the access token cannot be automatically renewed.
		 * 
		 * If this is an impersonated login, they user will be logged off
		 * immidiately.
		 */
		exports.credentialsOrLogout = function () {
			var ModalService = $injector.get('ModalService'),
				logoutTimeout = undefined;

			if (exports.isImpersonating()) {
				$state.go('main').then(function() {
					exports.logout();
					ModalService.create('logged-out').open();
				});
			} else {
				var renewSessionModal = ModalService.create('renew-session');
				expirePhase = true;
				logoutTimeout = startLogoutTimeout(5, function() {
					renewSessionModal.close()
				});

				renewSessionModal.linkScope({
					renewSession: function(data) {
						exports.authenticate(data).then(function() {
							$timeout.cancel(logoutTimeout);
							expirePhase = false;
							renewSessionModal.close();
							$state.go('dashboard.main.pages', {page: 'positions'});
						}, function () {
							NotificationService.warning('STR_INCORRECT_CREDENTIALS');
						});
					}
				});

				renewSessionModal.open();
			}
		};

		/**
		 * This is only used in conjunction with exports.credentialsOrLogout,
		 * which will trigger the logged out modal, if the timeout is triggered.
		 * 
		 * Accepts a callback, to be executed, when the timeout is triggered.
		 * @param {integer} minutes 
		 * @param {function} [cb]
		 * 
		 * @returns {Promise}
		 */
		function startLogoutTimeout (minutes, cb) {
			var ModalService = $injector.get('ModalService')

			return $timeout(function() {
				if (typeof cb === "function")
					cb();

				$state.go('main').then(function() {
					exports.logout();
					ModalService.create('logged-out').open();
				});
			}, minutes * 60 * 1000);
		}

		return exports;
	}
})();